'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = require('immutable');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ChatHeadingConfigPropType = require('ui-addon-conversations/chat-heading-config/prop-types/ChatHeadingConfigPropType');

var _ChatHeadingConfigPropType2 = _interopRequireDefault(_ChatHeadingConfigPropType);

var _RecordPropType = require('ui-addon-conversations/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

var _ChatWidgetLocaleContext = require('../ChatWidgetLocaleContext');

var _ThreadListHeader = require('./ThreadListHeader');

var _ThreadListHeader2 = _interopRequireDefault(_ThreadListHeader);

var _WidgetHeaderAvatarWrapper = require('./WidgetHeaderAvatarWrapper');

var _WidgetHeaderAvatarWrapper2 = _interopRequireDefault(_WidgetHeaderAvatarWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WidgetHeaderContent = function (_React$Component) {
  _inherits(WidgetHeaderContent, _React$Component);

  function WidgetHeaderContent() {
    _classCallCheck(this, WidgetHeaderContent);

    return _possibleConstructorReturn(this, (WidgetHeaderContent.__proto__ || Object.getPrototypeOf(WidgetHeaderContent)).apply(this, arguments));
  }

  _createClass(WidgetHeaderContent, [{
    key: 'render',
    value: function render() {
      var textColor = this.props.coloring.textColor;
      var _props = this.props,
          availabilityMessage = _props.availabilityMessage,
          chatHeadingConfig = _props.chatHeadingConfig,
          chatHeadingResponders = _props.chatHeadingResponders,
          createNewThread = _props.createNewThread,
          mobile = _props.mobile,
          showAvailabilityMessage = _props.showAvailabilityMessage,
          showStatusIndicator = _props.showStatusIndicator,
          viewingThreadList = _props.viewingThreadList;


      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        viewingThreadList ? _react2.default.createElement(_ThreadListHeader2.default, {
          createNewThread: createNewThread,
          textColor: textColor,
          mobile: mobile
        }) : _react2.default.createElement(
          _ChatWidgetLocaleContext.ChatWidgetLocaleContextConsumer,
          null,
          function (locale) {
            return _react2.default.createElement(_WidgetHeaderAvatarWrapper2.default, {
              availabilityMessage: availabilityMessage,
              borderColor: textColor,
              chatHeadingConfig: chatHeadingConfig,
              chatHeadingResponders: chatHeadingResponders,
              locale: locale,
              mobile: mobile,
              showAvailabilityMessage: showAvailabilityMessage,
              showStatusIndicator: showStatusIndicator
            });
          }
        )
      );
    }
  }]);

  return WidgetHeaderContent;
}(_react2.default.Component);

WidgetHeaderContent.propTypes = {
  availabilityMessage: _react.PropTypes.string,
  chatHeadingConfig: _ChatHeadingConfigPropType2.default.isRequired,
  chatHeadingResponders: _react.PropTypes.instanceOf(_immutable.List).isRequired,
  coloring: (0, _RecordPropType2.default)('ColoringRecord').isRequired,
  createNewThread: _react.PropTypes.func.isRequired,
  mobile: _react.PropTypes.bool,
  showAvailabilityMessage: _react.PropTypes.bool.isRequired,
  showStatusIndicator: _react.PropTypes.bool.isRequired,
  viewingThreadList: _react.PropTypes.bool
};

exports.default = WidgetHeaderContent;
module.exports = exports['default'];